import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Select } from "antd";
import { FaArrowLeft } from "react-icons/fa";
import axios from "axios";

import styles from "./BarraAreaAlunoConteudos.module.scss";

const { Option } = Select;

const BarraAreaAlunoConteudos = ({ disciplinas, codigoCurso, onChangeDisciplina, code }) => {
    const location = useLocation();

    const path = location.pathname;

    const menuAtivo = path.includes("/conteudos/") ? "conteudos" : path.includes("/drive/") ? "drive" : "";

    const params = useParams();
    const entidade = params.entidade;
    const id = params.id;

    const onChange = (value, option) => {
        const nomeDisciplina = option.props.children;

        onChangeDisciplina(value, nomeDisciplina);
    };

    const [curso, setCurso] = useState(undefined);

    const nomeCurso = () => {
        axios({
            method: "get",
            url: "/api/area-aluno/info-turma",
            params: {
                code
            }
        }).then(response => {
            setCurso(response.data);
        });
    };

    useEffect(() => {
        nomeCurso();
    }, []);

    return (
        <div className={styles.barra}>
            <nav className={styles.menu}>
                <Link to={`/${entidade}/area-aluno/conteudos/${id}`} className={`${styles.menuItem} ${menuAtivo === "conteudos" ? styles.ativo : ""}`}>
                    Conteudos
                </Link>
                <Link to={`/${entidade}/area-aluno/drive/${id}`} className={`${styles.menuItem} ${menuAtivo === "drive" ? styles.ativo : ""}`}>
                    Drive
                </Link>
            </nav>
            <div className={styles.nome}>
                <span>{curso}</span>
            </div>
            <div className={styles.opcoes}>
                <Select
                    showSearch
                    className={styles.disciplinas}
                    placeholder="Selecione uma disciplina"
                    value={codigoCurso}
                    onChange={onChange}
                    optionFilterProp="children"
                    filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
                >
                    {disciplinas.map(disciplina => (
                        <Option key={disciplina.id} value={disciplina.id}>
                            {disciplina.nome}
                        </Option>
                    ))}
                </Select>

                <div className={styles.seta}>
                    <Link to={`/${entidade}/area-aluno`}>
                        <FaArrowLeft />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default BarraAreaAlunoConteudos;
